
import Bed from '@/assets/icons/fontawesome/duotone/bed.svg?inline'
import Coffee from '@/assets/icons/fontawesome/duotone/coffee.svg?inline'
import UserFriends from '@/assets/icons/fontawesome/duotone/user-friends.svg?inline'
import UtensilsAlt from '@/assets/icons/fontawesome/duotone/utensils-alt.svg?inline'

export default {
  components: {
    Bed,
    Coffee,
    UserFriends,
    UtensilsAlt,
  },
  props: {
    items: {
      type: [Array, null],
      default: null,
    },
    supplier: {
      type: [String, null],
      default: null,
    },
    uuid: {
      type: [String, null],
      default: null,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      modalRequestOpen: false,
      loading: false,
      request_file: null,
      roomId: null,
      rooms: this.items,
      request: null,
      errors: {},
    }
  },
  methods: {
    updateParameters(item) {
      this.roomId = item.id
      this.modalRequestOpen = true
      if (item.remarks) {
        this.request = item.remarks
      }
    },
    async sendRequest(id) {
      this.loading = 'request'
      this.errors = null

      const fd = new FormData()
      if (this.request_file) {
        fd.append('file', this.request_file)
      }
      fd.append('request', this.request)

      await this.$axios
        .$post(`/v3.1/admin/reservations/${this.uuid}/items/${id}/request`, fd)
        .then((response) => {
          this.request = response.data.remarks
          this.rooms.forEach((element) => {
            if (element.id === response.data.id) {
              element.remarks = this.request
            }
          })
          this.roomId = null
          this.modalRequestOpen = false
          this.$toast.success(this.$i18n.t('Successfully sent.'))
        })
        .catch((error) => {
          if (typeof error.response.data === 'object') {
            this.errors = error.response.data.errors

            if (error.response.data.errors.session) {
              this.error = error.response.data
            }
          } else {
            this.errors = { message: 'Something went wrong. Please try again.' }
          }
        })

      this.loading = false
    },
  },
}
